// Completa a propósito: en la app, un target="_blank" con ruta relativa se abre en el mismo WebView y se pierde lo
// escrito en el formulario. Con la dirección completa se abre en el navegador, como en la web
export const URL_POLITICA_PRIVACIDAD =
  "https://amonsul.netlify.app/politica-privacidad";
